import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeJp from '@angular/common/locales/ja';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { APIService } from './API.service';

registerLocaleData(localeJp);

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot([
      {
        path: '',
        component: AppComponent
      },
      {
        path: 'form',
        component: AppComponent
      },
      {
        path: 'form?id=',
        component: AppComponent
      },
      {
        path: 'list',
        component: AppComponent
      },
      {
        path: 'list?club_cd=',
        component: AppComponent
      }
    ]),
    FormsModule,
    HttpModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  providers: [
    APIService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
